import { useEffect, useState } from "react";
import { Trophy } from "lucide-react";
import { api } from "@/lib/apiClient";

const MEDAL = { 1: "text-amber-300", 2: "text-slate-300", 3: "text-orange-300" };

// Monthly top-sharers board: recognition only; the #1 becomes Partner of the Month.
export default function PartnerLeaderboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/partner/leaderboard").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const month = new Date(`${d.month}-01T12:00`).toLocaleDateString(undefined, { month: "long" });
  return (
    <div className="rounded-3xl border border-border bg-card/40 p-7 mb-8" data-testid="partner-leaderboard">
      <div className="flex items-start justify-between gap-4 mb-1">
        <h3 className="font-serif text-2xl">Top sharers · {month}</h3>
        <Trophy className="w-5 h-5 text-primary shrink-0" strokeWidth={1.5} />
      </div>
      <p className="text-xs text-muted-foreground mb-5">Ranked by new members this month. The month's top partner becomes Partner of the Month and is featured here.</p>
      {d.featured && (
        <div className="mb-5 rounded-2xl border border-amber-300/25 bg-amber-300/[0.05] px-4 py-3 text-sm" data-testid="leaderboard-featured">
          <span className="text-[10px] uppercase tracking-[0.2em] text-amber-300 block">Partner of the Month · {new Date(`${d.featured.month}-01T12:00`).toLocaleDateString(undefined, { month: "long" })}</span>
          <span className="font-serif text-lg">{d.featured.is_me ? "You" : d.featured.name}</span>
        </div>
      )}
      {d.top.length === 0 ? (
        <p className="text-sm text-muted-foreground" data-testid="leaderboard-empty">No one on the board yet this month. One paying member puts you on it.</p>
      ) : (
        <div className="divide-y divide-border">
          {d.top.map((r) => (
            <div key={r.rank} className={`flex items-center justify-between py-3 text-sm ${r.is_me ? "text-primary" : ""}`} data-testid={`leaderboard-row-${r.rank}`}>
              <span className="flex items-center gap-3">
                <span className={`w-6 font-serif text-lg ${MEDAL[r.rank] || "text-muted-foreground"}`}>{r.rank}</span>
                {r.is_me ? "You" : r.name}
              </span>
              <span className="text-xs text-muted-foreground">{r.count} new {r.count === 1 ? "member" : "members"}</span>
            </div>
          ))}
        </div>
      )}
      {d.me && d.me.rank > 10 && <p className="text-xs text-primary mt-4" data-testid="leaderboard-me">You're #{d.me.rank} with {d.me.count}.</p>}
    </div>
  );
}
